import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Index from '@/components/Index'
import Login from '@/components/user/Login'
import Register from '@/components/user/Register'
import Recharge from '@/components/recharge/Index'
import RedeemLog from '@/components/recharge/RedeemLog'
import RechargePay from '@/components/recharge/Pay'
import RechargeLog from '@/components/recharge/Log'
import RechargeRedeemGame from '@/components/recharge/RedeemGame'
import RechargeSuccess from '@/components/recharge/Success'
import User from '@/components/user/Index'
import Service from '@/components/service/Index'
import ServiceFaq from '@/components/service/Faq'
import ServiceFaqItem from '@/components/service/FaqItem'
import ServiceLog from '@/components/service/Log'
import Job from '@/components/job/Index'
import JobDetail from '@/components/job/Detail'
import About from '@/components/about/Index'
import AboutProtect from '@/components/about/Protect'
import AboutProtocol from '@/components/about/Protocol'
import AboutContact from '@/components/about/Contact'
import AboutLaw from '@/components/about/Law'
import AboutPrivacy from '@/components/about/Privacy'
import NewsItem from '@/components/news/Item'
import NewsNewGame from '@/components/news/NewGame'
import NewsList from '@/components/news/List'
import Inner from '@/components/news/Inner'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/inner',
      component: Inner
    },
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          name: 'Index',
          component: Index
        },
        {
            path : '/login',
            component : Login
        },
        {
            path : '/register',
            component : Register
        },
        {
          path: '/recharge',
          name : 'Recharge',
          component: Recharge
        },
        {
          path: '/recharge/pay',
          component: RechargePay
        },
        {
          path: '/recharge/log',
          component: RechargeLog
        },
        {
          path: '/recharge/redeem/log',
          component: RedeemLog
        },
        {
          path: '/recharge/redeem-game',
          component: RechargeRedeemGame
        }, 
        {
          path: '/recharge/success',
          component: RechargeSuccess
        }, 
        {
          path: '/user',
          component: User
        }, 
        {
          path: '/service',
          component: Service
        }, 
        {
          path: '/service/faq',
          component: ServiceFaq
        }, 
        {
          path : '/service/faq/item',
          component : ServiceFaqItem
        },
        {
          path: '/service/log',
          component: ServiceLog
        }, 
        {
          path: '/job',
          component: Job
        }, 
        {
          path: '/job/detail',
          component: JobDetail
        }, 
        {
          path: '/about',
          component: About
        }, 
        {
          path: '/about/protocol',
          component: AboutProtocol
        }, 
        {
          path: '/about/law',
          component: AboutLaw
        }, 
        {
          path: '/about/privacy',
          component: AboutPrivacy
        },
        {
          path: '/about/protect',
          component: AboutProtect
        }, 
        {
          path: '/about/contact',
          component: AboutContact
        }, 
        {
          path: '/news/item',
          component: NewsItem
        }, 
        {
          path: '/news/new-game',
          component: NewsNewGame
        }, 
        {
          path: '/news/list',
          component: NewsList
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js